module.exports = __webpack_public_path__ + "static/media/Rédigersonrapportdactivitélycée.51c73032.pdf";